import { useState } from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import DeleteIcon from '@material-ui/icons/Delete';
import { colors } from "material-ui/styles";
import IconCancel from "@material-ui/icons/Cancel";
import ActionDelete from "@material-ui/icons/Delete";

import ModalComponent from "../../../components/ModalComponent";

export function DeleteCycleModal({ record }) {
  const [open, setOpen] = useState(false);
  const [ordersCount, setOrdersCount] = useState(0);
  const notify = useNotify();
  const refresh = useRefresh();
  const condition = ordersCount.length <= 0 ? "? Não há pedidos associados." : <span>junto com <b>{ordersCount}</b> pedido(s) associado(s)?</span>  
  const deletionMessage = <p>Deseja excluir o ciclo <b>{record?.id}</b> {condition} Ao confirmar, não será possível reverter essa operação.</p>

  const handleClose = () => setOpen(false);
  const handleOpen = async () => {
    const url = `${process.env.REACT_APP_API_URL}/orders/count-by-cycle/${record.id}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: new Headers({
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        const canDelete = data?.ordersCount?.canDelete;

        if (canDelete) {
          setOpen(true);
          setOrdersCount(data?.ordersCount?.count);
        } else {
          setOpen(false);
          const errorMessage = data?.ordersCount?.message || data?.message || "Esse ciclo não pode ser excluído.";
          notify(errorMessage, { type: "warning" });
        }
      }
    } catch (err) {
      notify(
        err.message || "Erro ao verificar pedidos associados ao ciclo.",
        { type: "warning" }
      );
    }
  };

  const handleDelete = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(`${apiUrl}/cycles/${record.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao excluir ciclo');
      }

      notify("Ciclo deletado com sucesso", { type: "success" });
      setOpen(false);
    } catch (err) {
      notify(err.message || "Erro ao excluir ciclo", { type: "warning" });
      setOpen(false);
    }
    refresh();
  };

  return (
    <>
      <Button
        label="Deletar"
        style={{ color: colors.red500 }}
        onClick={handleOpen}
      >
        <DeleteIcon />
      </Button>
      <ModalComponent
        open={open}
        onClose={handleClose}
        title="Confirmar a exclusão de ciclo"
        content={<span>{deletionMessage}</span>}
        actions={
          <>
            <Button onClick={handleClose} label="Cancelar">
              <IconCancel />
            </Button>

            <Button
              style={{ color: colors.red500 }}
              onClick={handleDelete}
              label="Deletar"
            >
              <ActionDelete />
            </Button>
          </>
        }
      />
    </>
  );
}
